import {BasketAdd} from 'app.vue.components.basket.mixin';

export const BasketButton = {
    mixins: [BasketAdd],
    props: {
		productid: {
			type: Number,
			required: true
		}
	},
    created () {
        this.form.offers[this.productid] = 1;
    },
	template: /*vue-html*/`
        <div class="lineup-item__btns">
            <div class="lineup-counts">
                <div v-on:click.stop="changeQnt(productid,-1)" class="lineup-counts__btn minus">-</div>
                <div class="lineup-counts__value">{{form.offers[productid]?form.offers[productid]:0}}</div>
                <div v-on:click.stop="changeQnt(productid,+1)" class="lineup-counts__btn plus">+</div>
            </div>
            <div 
                    class="lineup-item__basket button" 
                    v-on:click="add"
                    v-if="basketItemCnt"
                >в корзине {{basketItemCnt}}</div>
            <div v-else class="lineup-item__basket button" v-on:click="add">в корзину</div>
        </div>
	`
}
